import * as React from 'react'

function SvgTz(props) {
	return (
		<svg viewBox="0 0 72 48" width="1em" height="1em" {...props}>
			<path d="M0 48V0h72z" fill="#1eb53a" />
			<path d="M0 48h72V0z" fill="#00a3dd" />
			<path d="M0 48L72 0" stroke="#fcd116" strokeWidth={19} />
			<path d="M0 48L72 0" stroke="#000" strokeWidth={13} />
		</svg>
	)
}

export default SvgTz
